import ConversionResultFormatter from "../formatters/conversionResultFormatter.js";

class Unit{
    constructor(id, fromBaseUnitFactor, name, symbols) {
        if (!id){
            throw new TypeError('id cannot be empty');
        }

        if (typeof(id) !== 'string'){
            throw new TypeError('id must be an string');
        }

        if (typeof(fromBaseUnitFactor) !== "number"){
            throw new TypeError('fromBaseUnitFactor must be numeric');
        }

        if (!(symbols instanceof Array)){
            throw new TypeError('symbols must be an array');
        }

        this.id = id;
        this.baseUnitFactor = fromBaseUnitFactor;
        this.name = name;
        this.symbols = symbols;
        this.formatter = null;
    }

    convertFromBase(valueInBaseSystem){
        return valueInBaseSystem * this.baseUnitFactor;
    }

    convertToBase(valueToConvert){
        return valueToConvert / this.baseUnitFactor;
    }

    setFormatter(formatter){
        if (!(formatter instanceof ConversionResultFormatter)){
            throw new TypeError('formatter should be an instance of ConversionResultFormatter class');
        }

        this.formatter = formatter;
    }

    hasFormatter(){
        return this.formatter && this.formatter instanceof ConversionResultFormatter;
    }

    getSymbol(index){
        const symbol = this.symbols[index];
        if (typeof(symbol) === 'undefined'){
            return '';
        }

        return symbol;
    }
}

export default Unit;